<template>
  <div class="flex flex-col mb-48 relative">
    <!--<sound-wave class="absolute w-full top-28 lg:top-0 z-0 opacity-75"></sound-wave>-->
    <h1 class="font-medium text-2xl lg:text-4xl text-white border-b
    border-white pb-2 lg:mx-32 mt-32 z-10 w-11/12 lg:w-auto mx-auto
    flex justify-center uppercase md:normal-case">
        {{$t('menu.teachers')}}
    </h1>
    <div class="flex justify-center w-full mt-0 md:mt-12 z-10">
        <!--<search-for-alph class="mr-24 w-auto"></search-for-alph>-->
        <teacher-list></teacher-list>
    </div>
  </div>
</template>

<script>
import TeacherList from '../components/teachers/TeacherList.vue';
// import SearchForAlph from '../components/SearchForAlph.vue';
// import SoundWave from '../components/graphics/SoundWave.vue';

export default {
  components: {
    TeacherList,
  },
};
</script>
